import { combineReducers } from 'redux';

import productNotify from 'reducers/detail/sharing/productNotify';
import reportAnError from 'reducers/detail/sharing/reportAnError';

export default combineReducers({
  productNotify,
  reportAnError
});
